export default "__VITE_ASSET__8201c06f__"